import { render, staticRenderFns } from "./InsertionLevelInput.vue?vue&type=template&id=f2dbf462&"
import script from "./InsertionLevelInput.vue?vue&type=script&lang=js&"
export * from "./InsertionLevelInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports